module.exports = __webpack_public_path__ + "static/media/YB5F10_1.156bf309.jpg";